<template>
  <div class="issue-invoice">
    <div class="contain">
      <div class="contain-title">
        <span class="contain-title-content">该订单包含<span class="blue"> {{ orderList.length }} </span>张发票，总金额：</span>
        <span class="contain-title-content blue">￥{{ totalAmount }}</span>
      </div>
      <div class="content">
        <div class="content-item" v-for="(item, index) in orderList" :key="index" :class="{ 'gray': [0, 3, 6].includes(item.invoiceStatus) }">
          <!-- 标题 -->
          <div class="content-item-title">
            <div class="content-item-title-left bold">{{item.titleName || ''}}</div>
            <div 
              class="content-item-title-right"
              :class="{ 
                'blue': [-1, 2].includes(item.invoiceStatus),
                'gray': [0, 3, 6].includes(item.invoiceStatus)
              }"
            >{{issueStatus[item.invoiceStatus] || ''}}</div>
          </div>
          <!-- 金额 -->
          <div class="content-item-money" :class="{ 'gray': [0, 3, 6].includes(item.invoiceStatus) }">金额：￥{{item.amount || '0.00'}}</div>
          <!-- 二维码 -->
          <div class="content-qr">
            <div v-if="!item.errMsg" class="content-qr-img">
              <!-- 二维码容器 -->
              <div :id="'item' + index" class="qrcode"></div>
              <!-- 生成的二维码图片 -->
              <img v-if="qrCodeList[index]" class="content-qr-img-image" :src="qrCodeList[index]"></img>
              <!-- 遮罩层 + 图片标识 -->
              <div v-if="[0, 3, 6].includes(item.invoiceStatus)" class="content-qr-img-mark">
                <img class="content-qr-img-mark-image" :src="markImgSrcInfo[item.invoiceStatus]"></img>
              </div>
            </div>
            <div v-if="!item.errMsg && [-1, 2].includes(item.invoiceStatus)" class="content-qr-text">长按识别二维码开发票</div>
            <div v-if="!!item.errMsg" class="content-qr-text yellow">
              <i class="el-icon-warning"></i>
              <span>{{item.errMsg}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import req from '@/utils/request'
import { imgArr } from "@/assets/images/img.js"
import QRCode from 'qrcodejs2'
import { Loading } from 'element-ui'
const orderTypeNameInfo = {
  '1': '中药处方',
  '2': '理疗处方',
  '3': '隐秘处方',
  '4': '非处方项目',
  '15': '中成药处方'
}
// 订单类型排序
const orderTypeSortList = ['1', '15', '2', '4', '3']
export default {
  name: 'issueInvoice',
  data() {
    return {
      imgArr,
      totalAmount: '0.00',
      orderList: [],
      qrCodeList: [],
      issueStatus: {
        '0': '已开票',
        '-1': '待开票',
        '2': '待开票',
        '3': '已红冲',
        '6': '已作废',
      },
      markImgSrcInfo: {
        '0': imgArr.yiKaiPiao,
        '2': imgArr.kaiPiaoZhong,
        '3': imgArr.yiHongChong,
        '6': imgArr.yiZuoFei
      }
    }
  },
  beforeCreate() {
    document.title = '订单列表'
  },
  created() {
    this.getOrderList()
  },
  methods: {
    async getOrderList() {

      const loading = Loading.service()

      const params = {
        orderId: this.$route.query.orderId || ''
      }
      if (!params.orderId) return alert('订单编号不能为空')
      
      const res = await req.get('/invoice/info', params)

      loading.close()

      if (res.code === 200) {
        res.data = res.data || {}
        this.totalAmount = res.data.totalAmount || '0.00'

        const list = res.data && res.data.detailList.filter(v => { return v.amount > 0 }) || []
        this.getResultOrderList(list)
      }
    },

    // 处理列表数据（排序）
    getResultOrderList(detailList) {
      const recipeTypeList = [...new Set(detailList.map(item => item.recipeType))]
      const obj = {}
      recipeTypeList.forEach(el => {
        const sortList = detailList.filter(item => item.recipeType === el).sort((a, b) => a.sort - b.sort)
        obj[el] = sortList.map((item, index) => ({
          ...item,
          titleName: orderTypeNameInfo[el] + (sortList.length > 1 ? (index + 1) : '')
        }))
      })
      this.orderList = orderTypeSortList.map(item => obj[item]).flat().filter(item => !!item)

      this.$nextTick(() => {
        this.orderList.forEach((el, index) => {
          const text = el.qrCode || ''
          let qrCodeImg = ''
          if (text) {
            const dom = document.getElementById('item' + index)
            this.crateQrCode(dom, text)
            qrCodeImg = dom.querySelector('canvas').toDataURL('image/png')
          }
          this.$set(this.qrCodeList, index, qrCodeImg)
        })
      })

    },

    // 生成二维码
    crateQrCode(dom, text = '') {
      return new QRCode(dom, {
        width: 120,
        height: 120,
        text
      });
    }
  }
}
</script>

<style lang="less" scoped>
.issue-invoice {
  min-height: 100vh;
  font-size: 15px;
  background-color: #F8F8F8;
}

.contain {
  padding: 10px;
}

// 标题样式
.contain-title {
  padding: 6px 0;
  font-size: 0px;
}

.contain-title-content {
  font-size: 15px;
  color: #666666;
}

// 内容部分
.content-item {
  margin-top: 10px;
  padding: 12px;
  background: #FFFFFF;
  border-radius: 8px;
}

.content-item-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

// 订单金额
.content-item-money {
  padding: 12px 0 10px;
  border-bottom: 2px dashed #F1F1F1;
  color: #666666;
}

// qrcode样式
.content-qr {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.content-qr-img {
  position: relative;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 120px;
  height: 120px;
  background-color: #F1F1F1;
}

.qrcode {
  display: none;
}

.content-qr-img-image {
  width: 100%;
  height: 100%;
}

.content-qr-img-mark {
  position: absolute;
  left: 0;
  top: 0;
  width: 120px;
  height: 120px;
  background-color: rgba(255, 255, 255, 0.75);
}

.content-qr-img-mark-image {
  position: absolute;
  right: -42px;
  bottom: -6px;
  width: 57px;
  height: 57px;

}

.content-qr-text {
  margin: 10px 0 6px;
  font-size: 12px;
  color: #666666;
}

.el-icon-warning {
  margin-right: 2px;
  font-size: 16px;
  transform: translateY(1px) rotate(180deg);
}

.bold {
  font-weight: 600;
}

.blue {
  color: #1890FF;
}

.yellow {
  color: #FE8F1F;
}

.gray {
  color: #C6C6C6;
}
</style>